import { useEffect, useId } from 'react'
import Highcharts from 'highcharts/highmaps'
import HC_map from 'highcharts/modules/map'
import HC_data from 'highcharts/modules/data'
import ChartSkeleton from '../../skeleton/ChartSkeleton'
import BaseChart from '../../charts/BaseChart'

interface IVisualizationsBasicMapProps {
  chartData: string
  mapData: object
  tooltipTitle?: string
  long?: boolean
}

const VisualizationsBasicMap = (props: IVisualizationsBasicMapProps) => {
  const { chartData, mapData, tooltipTitle, long } = props
  const chartId = useId()

  useEffect(() => {
    if (typeof HC_map === 'function') {
      HC_map(Highcharts)
    }
    if (typeof HC_data === 'function') {
      HC_data(Highcharts)
    }
  }, [])

  const parsedData = chartData
    .split('\n')
    .slice(1)
    .map((line) => {
      const parts = line.split(',')
      if (parts.length < 3) return null
      const [, code, value] = parts
      return {
        code: code.trim(),
        value: Number(value.trim()),
      }
    })
    .filter(Boolean)

  const options = {
    chart: {
      map: mapData,
      height: `${long ? '850px' : '400px'}`,
      backgroundColor: 'transparent',
    },
    title: {
      text: null,
    },
    mapNavigation: {
      enabled: true,
      buttonOptions: {
        verticalAlign: 'bottom',
      },
    },
    colorAxis: {
      min: 1,
      type: 'logarithmic',
      minColor: '#fff4e6',
      maxColor: '#d9480f',
      stops: [
        [0, '#fff4e6'],
        [0.67, '#ff922b'],
        [1, '#d9480f'],
      ],
    },
    tooltip: {
      valueDecimals: 0,
      valueSuffix: '',
    },
    series: [
      {
        name: tooltipTitle ? tooltipTitle : 'Threat Events',
        joinBy: ['iso-a3', 'code'],
        data: parsedData,
        dataLabels: {
          enabled: false,
          format: '{point.name}',
          style: {
            fontWeight: 'normal',
          },
        },
        tooltip: {
          pointFormat: '{point.name}: {point.value}',
        },
      },
    ],
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
  }

  return (
    <>
      {mapData && chartData && <BaseChart options={options} id={chartId} isMap={true} />}
      {(!mapData || !chartData) && <ChartSkeleton fullWidth />}
    </>
  )
}

export default VisualizationsBasicMap